const reqSvgs = require.context('assets/img/svg', true, /\.svg$/);

export const hasSvgIcon = (name: string): boolean =>
  reqSvgs.keys().includes(`./${name}.svg`);
